// wi_6b5960f9-952c-48fc-ab25-68e9f9e5b2da: who may use the 3D demo viewer.
// A build-time list of user ids, not the self-serve beta toggle in Settings.
export const VIEWER_3D_FEATURE = 'wi_6b5960f9-952c-48fc-ab25-68e9f9e5b2da';

export function canUse3dViewer(user) {
  if (user?.id === undefined || user?.id === null) return false;
  const ids = (import.meta.env.VITE_VIEWER_3D_USER_IDS || '')
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);
  return ids.includes(String(user.id));
}

export function hasWebgl2() {
  try {
    return Boolean(document.createElement('canvas').getContext('webgl2'));
  } catch {
    return false;
  }
}
